import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "140",
  height: "140",
  viewBox: "0 0 140 140",
  fill: "#CDD0D8"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]
const _hoisted_7 = ["fill"]
const _hoisted_8 = ["fill"]
const _hoisted_9 = ["fill"]
const _hoisted_10 = ["fill"]
const _hoisted_11 = ["fill"]
const _hoisted_12 = ["fill"]
const _hoisted_13 = ["fill"]
const _hoisted_14 = ["fill"]
const _hoisted_15 = ["fill"]
const _hoisted_16 = ["fill"]
const _hoisted_17 = ["fill"]
const _hoisted_18 = ["fill"]
const _hoisted_19 = ["fill"]
const _hoisted_20 = ["fill"]
const _hoisted_21 = ["fill"]
const _hoisted_22 = ["fill"]
const _hoisted_23 = ["fill"]
const _hoisted_24 = ["fill"]
const _hoisted_25 = ["fill"]
const _hoisted_26 = ["fill"]
const _hoisted_27 = ["fill"]
const _hoisted_28 = ["fill"]
const _hoisted_29 = ["fill"]
const _hoisted_30 = ["fill"]
const _hoisted_31 = ["fill"]
const _hoisted_32 = ["fill"]
const _hoisted_33 = ["fill"]
const _hoisted_34 = ["fill"]
const _hoisted_35 = ["fill"]
const _hoisted_36 = ["fill"]
const _hoisted_37 = ["fill"]

import { ref, onBeforeMount, onBeforeUnmount } from 'vue'
import { SEC_BY_MS } from '@/constants/datetime'


export default /*#__PURE__*/_defineComponent({
  name: 'CircularProgress',
  setup(__props) {

let timer: number
const circle = ref(0)

onBeforeMount(() => {
  timer = window.setInterval(() => {
    circle.value = (circle.value + 1) % 37
  }, SEC_BY_MS/36)
})

onBeforeUnmount(() => {
  if (timer) {
    clearInterval(timer)
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M71.5444 21.969C73.2777 22.0269 74.9916 22.1751 76.6798 22.4135L79.2571 7.79999C76.7313 7.42628 74.1604 7.19432 71.5509 7.12988V21.969H71.5444Z",
      fill: circle.value >= 1 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M79.8511 22.968C81.5457 23.3224 83.2016 23.7799 84.8254 24.3083L89.9027 10.3519C87.4736 9.54007 84.98 8.86996 82.4284 8.35449L79.8511 22.968Z",
      fill: circle.value >= 2 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M87.8545 25.4095C89.4524 26.0538 91.0117 26.7819 92.5195 27.5873L99.9422 14.7264C97.6871 13.4957 95.3417 12.4003 92.9319 11.4531L87.8545 25.4095Z",
      fill: circle.value >= 3 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      d: "M95.3022 29.2125C96.7584 30.1275 98.1631 31.1133 99.5162 32.1765L109.065 20.7975C107.049 19.1931 104.935 17.7047 102.731 16.3516L95.3022 29.219V29.2125Z",
      fill: circle.value >= 4 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_5),
    _createElementVNode("path", {
      d: "M105.632 37.8783L117.004 28.3357C115.297 26.4026 113.467 24.5727 111.534 22.8652L101.991 34.2378C103.267 35.3847 104.485 36.6025 105.632 37.8783Z",
      fill: circle.value >= 5 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_6),
    _createElementVNode("path", {
      d: "M107.693 40.3528C108.75 41.6994 109.742 43.1041 110.657 44.5667L123.525 37.1375C122.172 34.9339 120.683 32.8205 119.079 30.8037L107.7 40.3528H107.693Z",
      fill: circle.value >= 6 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_7),
    _createElementVNode("path", {
      d: "M112.275 47.3505C113.08 48.8582 113.808 50.4175 114.453 52.0155L128.409 46.9381C127.462 44.5219 126.36 42.1829 125.136 39.9277L112.275 47.3505Z",
      fill: circle.value >= 7 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_8),
    _createElementVNode("path", {
      d: "M129.517 49.96L115.561 55.0373C116.089 56.6611 116.547 58.317 116.901 60.0116L131.515 57.4343C130.999 54.8827 130.329 52.3891 129.517 49.96Z",
      fill: circle.value >= 8 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_9),
    _createElementVNode("path", {
      d: "M117.455 63.1881C117.693 64.8698 117.842 66.5837 117.9 68.3235H132.739C132.674 65.7074 132.442 63.1365 132.069 60.6172L117.455 63.1945V63.1881Z",
      fill: circle.value >= 9 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_10),
    _createElementVNode("path", {
      d: "M117.894 71.5469C117.836 73.2801 117.688 74.9941 117.449 76.6822L132.063 79.2596C132.436 76.7338 132.668 74.1629 132.733 71.5533H117.894V71.5469Z",
      fill: circle.value >= 10 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_11),
    _createElementVNode("path", {
      d: "M116.901 79.8516C116.547 81.5462 116.089 83.2021 115.561 84.8258L129.517 89.9032C130.329 87.4741 130.999 84.9805 131.515 82.4289L116.901 79.8516Z",
      fill: circle.value >= 11 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_12),
    _createElementVNode("path", {
      d: "M114.453 87.8541C113.808 89.4521 113.08 91.0114 112.275 92.5191L125.136 99.9418C126.367 97.6867 127.462 95.3413 128.409 92.9315L114.453 87.8477V87.8541Z",
      fill: circle.value >= 12 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_13),
    _createElementVNode("path", {
      d: "M110.657 95.3037C109.742 96.7599 108.757 98.1646 107.693 99.5177L119.072 109.067C120.677 107.05 122.165 104.937 123.518 102.733L110.651 95.3037H110.657Z",
      fill: circle.value >= 13 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_14),
    _createElementVNode("path", {
      d: "M105.632 101.992C104.485 103.268 103.267 104.486 101.991 105.633L111.534 117.005C113.467 115.298 115.297 113.468 117.004 111.535L105.632 101.992Z",
      fill: circle.value >= 14 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_15),
    _createElementVNode("path", {
      d: "M99.5162 107.694C98.1695 108.751 96.7649 109.743 95.3022 110.658L102.731 123.526C104.935 122.173 107.049 120.684 109.065 119.08L99.5162 107.701V107.694Z",
      fill: circle.value >= 15 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_16),
    _createElementVNode("path", {
      d: "M92.5195 112.275C91.0117 113.081 89.4524 113.809 87.8545 114.453L92.9319 128.41C95.3481 127.462 97.6871 126.361 99.9422 125.136L92.5195 112.275Z",
      fill: circle.value >= 16 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_17),
    _createElementVNode("path", {
      d: "M84.8256 115.562C83.2019 116.09 81.5459 116.547 79.8513 116.902L82.4287 131.515C84.9802 131 87.4738 130.33 89.903 129.518L84.8256 115.562Z",
      fill: circle.value >= 17 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_18),
    _createElementVNode("path", {
      d: "M76.6752 117.457C74.9934 117.695 73.2795 117.843 71.5398 117.901V132.74C74.1494 132.676 76.7267 132.444 79.2461 132.07L76.6687 117.457H76.6752Z",
      fill: circle.value >= 18 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_19),
    _createElementVNode("path", {
      d: "M68.3238 117.901C66.5905 117.843 64.8766 117.695 63.1884 117.457L60.6111 132.07C63.1369 132.444 65.7078 132.676 68.3173 132.74V117.901H68.3238Z",
      fill: circle.value >= 19 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_20),
    _createElementVNode("path", {
      d: "M60.018 116.902C58.3233 116.547 56.6674 116.09 55.0437 115.562L49.9663 129.518C52.3955 130.33 54.889 131 57.4406 131.515L60.018 116.902Z",
      fill: circle.value >= 20 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_21),
    _createElementVNode("path", {
      d: "M52.0135 114.453C50.4156 113.809 48.8563 113.081 47.3485 112.275L39.9258 125.136C42.181 126.367 44.5263 127.462 46.9362 128.41L52.0135 114.453Z",
      fill: circle.value >= 21 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_22),
    _createElementVNode("path", {
      d: "M44.5599 110.658C43.1037 109.743 41.699 108.757 40.3459 107.694L30.7969 119.073C32.8136 120.678 34.9271 122.166 37.1307 123.519L44.5599 110.652V110.658Z",
      fill: circle.value >= 22 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_23),
    _createElementVNode("path", {
      d: "M34.2368 101.992L22.8643 111.535C24.5717 113.468 26.4017 115.298 28.3347 117.005L37.8773 105.633C36.6015 104.486 35.3837 103.268 34.2368 101.992Z",
      fill: circle.value >= 23 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_24),
    _createElementVNode("path", {
      d: "M32.1678 99.5177C31.1111 98.171 30.1188 96.7664 29.2038 95.3037L16.3364 102.733C17.6895 104.937 19.1715 107.05 20.7823 109.067L32.1613 99.5177H32.1678Z",
      fill: circle.value >= 24 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_25),
    _createElementVNode("path", {
      d: "M27.5873 92.5195C26.7819 91.0117 26.0538 89.4524 25.4095 87.8545L11.4531 92.9319C12.4003 95.3481 13.5021 97.6871 14.7264 99.9422L27.5873 92.5195Z",
      fill: circle.value >= 25 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_26),
    _createElementVNode("path", {
      d: "M24.3068 84.8258C23.7784 83.2021 23.321 81.5462 22.9666 79.8516L8.35303 82.4289C8.8685 84.9805 9.53861 87.4741 10.3505 89.9032L24.3068 84.8258Z",
      fill: circle.value >= 26 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_27),
    _createElementVNode("path", {
      d: "M22.4126 76.6754C22.1742 74.9937 22.026 73.2797 21.968 71.54H7.12891C7.19334 74.1496 7.4253 76.7269 7.79902 79.2463L22.4126 76.669V76.6754Z",
      fill: circle.value >= 27 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_28),
    _createElementVNode("path", {
      d: "M21.968 68.324C22.026 66.5908 22.1742 64.8768 22.4126 63.1887L7.79902 60.6113C7.4253 63.1371 7.19334 65.708 7.12891 68.3176H21.968V68.324Z",
      fill: circle.value >= 28 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_29),
    _createElementVNode("path", {
      d: "M22.9666 60.0184C23.321 58.3238 23.7784 56.6679 24.3068 55.0442L10.3505 49.9668C9.53861 52.3959 8.8685 54.8895 8.35303 57.4411L22.9666 60.0184Z",
      fill: circle.value >= 29 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_30),
    _createElementVNode("path", {
      d: "M25.4095 52.0155C26.0538 50.4175 26.7819 48.8582 27.5873 47.3505L14.7264 39.9277C13.4957 42.1829 12.4003 44.5283 11.4531 46.9381L25.4095 52.0219V52.0155Z",
      fill: circle.value >= 30 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_31),
    _createElementVNode("path", {
      d: "M29.2106 44.5599C30.1255 43.1037 31.1114 41.699 32.1745 40.3459L20.7955 30.7969C19.1911 32.8136 17.7027 34.9271 16.3496 37.1307L29.217 44.5599H29.2106Z",
      fill: circle.value >= 31 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_32),
    _createElementVNode("path", {
      d: "M34.2368 37.8789C35.3837 36.6031 36.6015 35.3853 37.8773 34.2384L28.3347 22.8594C26.4017 24.5669 24.5717 26.3968 22.8643 28.3298L34.2368 37.8724V37.8789Z",
      fill: circle.value >= 32 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_33),
    _createElementVNode("path", {
      d: "M40.3518 32.1692C41.6985 31.1125 43.1031 30.1202 44.5658 29.2053L37.1366 16.3379C34.9329 17.691 32.8195 19.1794 30.8027 20.7838L40.3518 32.1628V32.1692Z",
      fill: circle.value >= 33 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_34),
    _createElementVNode("path", {
      d: "M47.3485 27.5873C48.8563 26.7819 50.4156 26.0538 52.0135 25.4095L46.9362 11.4531C44.5199 12.4003 42.181 13.5021 39.9258 14.7264L47.3485 27.5873Z",
      fill: circle.value >= 34 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_35),
    _createElementVNode("path", {
      d: "M55.0437 24.3083C56.6674 23.7799 58.3233 23.3224 60.018 22.968L57.4406 8.35449C54.889 8.86996 52.3955 9.54007 49.9663 10.3519L55.0437 24.3083Z",
      fill: circle.value >= 35 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_36),
    _createElementVNode("path", {
      d: "M63.1886 22.4135C64.8703 22.1751 66.5842 22.0269 68.3239 21.969V7.12988C65.7144 7.19432 63.137 7.42628 60.6177 7.79999L63.195 22.4135H63.1886Z",
      fill: circle.value >= 36 ? '#5061FA' : '#CDD0D8'
    }, null, 8, _hoisted_37)
  ]))
}
}

})